import { FOCUS } from "../data/content";
import { Reveal } from "./Reveal";

export const CoreIdentity = () => (
    <section
        data-testid="fokus-utama-section"
        aria-labelledby="fokus-utama-title"
        className="relative bg-bh-deep py-24 sm:py-32 overflow-hidden"
    >
        <div aria-hidden="true" className="absolute inset-0 pattern-star-gold opacity-[0.05]" />
        <div className="relative max-w-[1565px] mx-auto px-6 sm:px-8">
            <Reveal className="text-center mb-16 sm:mb-20">
                <p className="text-xs font-semibold uppercase tracking-[0.28em] text-bh-softgold mb-4">
                    {FOCUS.eyebrow}
                </p>
                <h2
                    id="fokus-utama-title"
                    data-testid="fokus-utama-title"
                    className="font-serif font-bold text-2xl sm:text-3xl lg:text-4xl text-white tracking-tight"
                >
                    {FOCUS.title}
                </h2>
                <span aria-hidden="true" className="block w-14 h-[2px] bg-bh-gold mx-auto mt-6" />
                <p className="mt-6 text-base sm:text-lg leading-relaxed text-white/70 max-w-2xl mx-auto">
                    {FOCUS.sub}
                </p>
            </Reveal>

            <div className="grid md:grid-cols-3 gap-10 md:gap-8 lg:gap-14">
                {FOCUS.items.map((item, i) => (
                    <Reveal key={item.number} delay={i * 0.14}>
                        <article
                            data-testid={`fokus-item-${item.title.toLowerCase().replace(/\s/g, "-")}`}
                            className="relative text-center md:text-left border-t border-white/10 pt-10"
                        >
                            <span
                                aria-hidden="true"
                                className="absolute top-6 right-0 md:right-auto md:left-0 md:-top-5 font-serif text-sm tracking-[0.3em] text-bh-gold/70"
                            >
                                {item.number}
                            </span>
                            <h3 className="font-serif font-bold text-5xl lg:text-6xl tracking-tight text-white mb-6">
                                {item.title}
                                <span aria-hidden="true" className="text-bh-gold">.</span>
                            </h3>
                            <p className="text-base leading-relaxed text-white/70 max-w-sm mx-auto md:mx-0">
                                {item.description}
                            </p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
